import { useState, useRef } from "react";

import "./index.css"

import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Form from 'react-bootstrap/Form';
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { SortUp, SortDown, Justify } from "react-bootstrap-icons";

import { filtrar } from "../../../util/Filtros";
import EctLogoSimples from '../../../assets/img/favi-ect.png';
interface Props {
  listaLoecSelecionada: any | null;
  listaLoecObjetosSelecionada: any | null;
  listaLoecObjetosSelecionadaFiltrada: any | null;
  setListaLoecObjetosSelecionadaFiltrada: (listaLoecObjetosSelecionadaFiltrada: any) => void;
  qtdObjetosSemBaixa: any | null;
  show: boolean;
  setShow: (show: boolean) => void;

}


const ModalListaLoec = ({ listaLoecSelecionada,
  listaLoecObjetosSelecionada,
  listaLoecObjetosSelecionadaFiltrada,
  setListaLoecObjetosSelecionadaFiltrada,
  qtdObjetosSemBaixa,
  show,
  setShow }: Props) => {

  const NAOBAIXADO = 'NÃO BAIXADO';

  const columns = [
    { label: "#", accessor: "#", sortable: false, className: "text-center primeira-coluna", classNameData: "text-center" },
    { label: "Objeto", accessor: "objeto", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Sistema Origem", accessor: "nomeSistemaOrigem", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Data Baixa", accessor: "dataCriacaoBaixa", sortable: true, className: "", classNameData: "" },
    { label: "Data Inserção Baixa", accessor: "dataInsercaoBaixa", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Evento", accessor: "eventoBaixa", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Motivo", accessor: "motivo", sortable: true, className: "text-center", classNameData: "text-center" },
    { label: "Descrição", accessor: "motivoDescricao", sortable: true, className: "text-center", classNameData: "text-center" },
  ];

  const columnsFiltrar = [
    "objeto", "nomeSistemaOrigem", "dataCriacaoBaixa", "dataInsercaoBaixa", "eventoBaixa", "motivo", "motivoDescricao"
  ];

  const divTable = useRef<null | HTMLInputElement>(null);
  const [filtro, setFiltro] = useState<string>('');
  const [sortField, setSortField] = useState("");
  const [order, setOrder] = useState("asc");
  const [showModalMotivosBaixas,setShowModalMotivosBaixas]=useState<boolean>(false);
  const handleClose = () => setShow(false);
  const handleCloseMotivosBaixas = () => setShowModalMotivosBaixas(false);
  const [ resumoListaMotivosBaixados, setResumoListaMotivosBaixados ] = useState<any>([]);


  const setFiltroInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    setFiltro(event.target.value)

    if (event.target.value && event.target.value !== '' && event.target.value.length > 0) {

      let res: any = filtrar(listaLoecObjetosSelecionada, columnsFiltrar, event.target.value);

      setListaLoecObjetosSelecionadaFiltrada(() => res)
    } else {
      setListaLoecObjetosSelecionadaFiltrada(() => listaLoecObjetosSelecionada)
    }

  }

  const handleSortingChange = (accessor: string) => {
    const sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    setSortField(accessor);
    setOrder(sortOrder);
    handleSorting(accessor, sortOrder);
  }
  const handleSorting = (sortField: string | number, sortOrder: string) => {

    if (sortField) {
      const sorted = [...listaLoecObjetosSelecionadaFiltrada].sort((a, b) => {
        if ((a as Record<string, any>)[sortField] === null) return 1;
        if ((b as Record<string, any>)[sortField] === null) return -1;
        if ((a as Record<string, any>)[sortField] === null && (b as Record<string, any>)[sortField] === null) return 0;
        return (
          (a as Record<string, any>)[sortField].toString().localeCompare((b as Record<string, any>)[sortField].toString(), "pt-BR", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });

      setListaLoecObjetosSelecionadaFiltrada(sorted);
    }
  };

  const criarResumoListaMotivosBaixas = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();

    let baixas = new Map<Number, any>();

    listaLoecObjetosSelecionadaFiltrada.forEach((b: { motivo: Number; motivoDescricao: any; eventoBaixa: any; })=>{
      let motivo = b.motivo ? b.motivo : 0;
      let descricao = motivo === 0 ? 'Não baixado(s)' : `${motivo} - ${b.motivoDescricao}`;
      if(baixas.has(motivo)){
        baixas.get(motivo).quantidade++;
      }else{
        baixas.set(motivo,{motivo: motivo, motivoDescricao: descricao, quantidade: 1, evento: b.eventoBaixa})
      }

    });
    setResumoListaMotivosBaixados(()=> Array.from(baixas.values()));

    setShowModalMotivosBaixas(()=>true);
  }


  return (
    <>
      <Modal className="mt-4" id="modal-lista-baixas"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <img src={EctLogoSimples}
              alt="Logo ECT"
              className="rounded me-2"
            />
            <strong className="me-auto">Sroconferencia - Baixas Distribuição Externa</strong>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">

          {<>
            <Form>
              <Form.Group as={Row} controlId="formModalListaLoec" className="mb-3 w-100">
                <Col sm={12} lg={4} xl={3}>
                  <Form.Control
                    type="search"
                    placeholder="Filtrar"
                    title="Digite algo para filtrar."
                    disabled={!filtro && (!listaLoecObjetosSelecionada || listaLoecObjetosSelecionada.length === 0)}
                    value={filtro}
                    onChange={setFiltroInput}
                  />
                </Col>
                <Col sm={12} lg={5} xl={7} className="pe-0">
                  <Row className="align-items-center h-100 w-100 border rounded">
                    <Col sm={3} className="fw-bold">Lista: <span className="badge bg-primary">{listaLoecSelecionada ? listaLoecSelecionada.numLista : ''}</span></Col>
                    <Col sm={2} className="fw-bold">Distrito: <span className="badge bg-primary">{listaLoecSelecionada ? listaLoecSelecionada.distrito : ''}</span></Col>
                    <Col sm={3} className="fw-bold">Qtd. Objetos: <span className="badge bg-primary">{listaLoecSelecionada ? listaLoecSelecionada.qtdItensOec : ''}</span></Col>
                    <Col sm={4} className="fw-bold">Qtd. Objetos Sem Baixa: <span className={!listaLoecSelecionada || !listaLoecObjetosSelecionadaFiltrada || qtdObjetosSemBaixa > 0 ? 'badge bg-warning' : "badge bg-primary"}>{qtdObjetosSemBaixa}</span></Col>
                  </Row>
                </Col>
                <Col sm={12} lg={3} xl={2} className="pe-0">
                  <Row className="align-items-center h-100 border border rounded">
                    <Col><Link to="#" onClick={(e) => criarResumoListaMotivosBaixas(e)}>Mais detalhes...</Link></Col>
                  </Row>
                </Col>

              </Form.Group>

            </Form>
            <div ref={divTable} className="mb-0">
              <Table id="tabela-lista-loec" responsive striped className="scroll mb-0">
                <thead>
                  <tr>
                    {columns.map(({ label, accessor, sortable, className }) => {

                      const cl = sortable ? sortField === accessor && order === "asc"
                        ? <SortUp className="icon-table-sortable" />
                        : sortField === accessor && order === "desc"
                          ? <SortDown className="icon-table-sortable" />
                          : <Justify className="icon-table-sortable" />
                        : "";

                      return (
                        <th
                          key={accessor}
                          className={`${sortable ? `${className} cursor-pointer` : `${className}`}`}
                          onClick={sortable ? () => handleSortingChange(accessor) : undefined}
                        >
                          {cl}
                          {label}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                {listaLoecObjetosSelecionadaFiltrada && listaLoecObjetosSelecionadaFiltrada.length > 0 ?

                  (<tbody>
                    {listaLoecObjetosSelecionadaFiltrada.map((data: any, index: number) => {

                      return (

                        <tr id={String(index)} key={index ? index : 0} className={(data as Record<string, any>)['motivoDescricao'] && (data as Record<string, any>)['motivoDescricao'].toUpperCase() !== NAOBAIXADO ? '' : 'row-sem-baixa'}>
                          {columns.map(({ accessor, classNameData }) => {

                            const tData = accessor === "#" ? index : (data as Record<string, any>)[accessor];

                            if (accessor === 'objeto') return <td id={accessor} key={accessor} className='text-center'><a onClick={(e) => e.stopPropagation()} title={`Clique para rastrear o objeto ${data.objeto}`} href={`${process.env.REACT_APP_URL_PAGE_RASTREAMENTO}?objetos=${data.objeto}`} target="_blank" rel="noopener noreferrer"><strong>{data.objeto}</strong></a></td>

                            return <td id={accessor} key={accessor} className={!classNameData || classNameData === "" ? "" : classNameData}>{tData}</td>
                          })}
                        </tr>
                      );
                    })}
                  </tbody>)

                  :

                  (<tbody><tr><td colSpan={columns.length} className="text-center"><strong className="text-center">Não encontrou dados.</strong></td></tr></tbody>)
                }

              </Table>
            </div>
          </>

          }

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {'Fechar'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal className="mt-4" id="modal-lista-baixas-motivos"
        show={showModalMotivosBaixas}
        onHide={handleCloseMotivosBaixas}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <img src={EctLogoSimples}
              alt="Logo ECT"
              className="rounded me-2"
            />
            <strong className="me-auto">Baixados por motivos</strong>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">

          {<>

            <div ref={divTable} className="mb-0">
            <Table id="table-lista-baixas-motivos" responsive striped className="scroll mb-0">
          <thead>
            <tr> 
                <th className="text-start w-83">Motivo e Descrição</th>
                <th className="text-center">Quantidade</th>
            </tr>
          </thead>
          {resumoListaMotivosBaixados && resumoListaMotivosBaixados.length > 0 ?

            (<tbody>
              {resumoListaMotivosBaixados.map((data: any, index: number) => {

                return (

                  <tr id={String(index)} key={index ? index : 0}>
                      <td id={String(index+(index/2+1))} key={index+(index/2+1)} className="text-start w-83">{data.motivoDescricao}</td>
                      <td id={String(index+(index+1))} key={index+(index+1)} className="text-center"><span className={data.motivo === 0 ? "badge bg-warning" : "badge bg-primary"}>{data.quantidade}</span></td>
                  </tr>
                );
              })}
            </tbody>)

          :

            (<tbody><tr><td colSpan={2} className="text-center"><strong className="text-center">Não encontrou dados.</strong></td></tr></tbody>)
          }

        </Table>
            </div>
          </>

          }

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseMotivosBaixas}>
            {'Fechar'}
          </Button>
        </Modal.Footer>
      </Modal>


    </>
  )
}

export default ModalListaLoec